import { use18n, useStore } from 'src/utils/v2_helper/common';
import { computed } from 'vue'

export const vouchers = [
  {
    productStoreId: '10170',
    voucherCode: 'DM02252258',
    voucherName: 'lll',
    voucherType: 'PROMO_GWP',
    minimumAmount: '60000',
    fixAmount: null,
    percentageAmount: null,
    giftProductId: '125523',
    giftProductName: 'PANGS GR',
    serviceTypeAllowedList: [
      'DINE_IN',
    ],
    fromDate: '2022-12-09',
    thruDate: '2022-12-11',
    fromTime: '00:00:00',
    thruTime: '23:59:59'
  },
  {
    productStoreId: '10170',
    voucherCode: 'DM02214596',
    voucherName: '555',
    voucherType: 'PROMO_PROD_PERCENT',
    minimumAmount: '50000',
    fixAmount: null,
    percentageAmount: '10.000000',
    giftProductId: null,
    giftProductName: null,
    serviceTypeAllowedList: [
      'DINE_IN',
      'PICK_UP',
      'FULL_DINE_IN'
    ],
    fromDate: '2022-12-09',
    thruDate: '2022-12-17',
    fromTime: '00:00:00',
    thruTime: '23:59:59'
  },
  {
    productStoreId: '10170',
    voucherCode: 'DM12525550',
    voucherName: 'ddd',
    voucherType: 'PROMO_PROD_AMOUNT',
    minimumAmount: '100000',
    fixAmount: '1234.000000',
    percentageAmount: null,
    giftProductId: null,
    giftProductName: null,
    serviceTypeAllowedList: [
      'PICK_UP',
      'DELIVERY',
    ],
    fromDate: '2022-12-08',
    thruDate: '2022-12-10',
    fromTime: '00:00:00',
    thruTime: '23:59:59'
  }
]

export const useServiceMap = () => {
  const { $t } = use18n();
  const store = useStore();
  const customize = computed(() => store.state?.prefetch?.storeInfo?.customize || {})
  const map = computed(() => ({
    PICK_UP: {
      label: customize.value.PICK_UP,
      icon: 'https://static.bakmigm.co.id/menu/391df4258a7b54e98a0dda9c7e9e8ba3.png',
    },
    DINE_IN: {
      label: customize.value.DINE_IN,
      icon: 'https://static.bakmigm.co.id/menu/7c15783ace60c63d5aefee0fa5b2cb0e.png',
    },
    FULL_DINE_IN: {
      label: customize.value.FULL_DINE_IN,
      icon: 'https://static.bakmigm.co.id/menu/7c15783ace60c63d5aefee0fa5b2cb0e.png',
    },
    DELIVERY: {
      label: customize.value.DELIVERY,
      icon: 'https://static.bakmigm.co.id/menu/9d361a344a8bc5437c2d3ccc91991227.png',
    },
    SCHEDULED_PICK_UP: {
      label: $t('home.pickupSchedule'),
      icon: 'https://static.bakmigm.co.id/menu/scheduled-pickup-0113.svg',
    },
    SCHEDULED_DELIVERY: {
      label: $t('home.deliverySchedule'),
      icon: 'https://static.bakmigm.co.id/menu/scheduled-delivery-0113.svg',
    },
  }))
  return map;
}
